import { useQuery } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import getUserRole from 'utils/jwt/getUserRole';
import { ROLES } from 'config';
import { getNotValidatedClassesApi } from './api';

const useNotValidatedClasses = () => {
  const { enqueueSnackbar } = useSnackbar();
  const role = getUserRole();

  const { data, isInitialLoading } = useQuery(['notValidatedClasses'], getNotValidatedClassesApi, {
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.message || error.message, { variant: 'error' });
    },
    keepPreviousData: false,
    enabled: role === ROLES.YFC_ADMIN || role === ROLES.SUPER_ADMIN || role === ROLES.FRANCHISE_REGION_ADMIN,

    select: ({ data }) => data,
  });

  return {
    classes: data || [],
    isLoading: isInitialLoading,
  };
};

export default useNotValidatedClasses;
